import React from "react";
import PropTypes from "prop-types";
import { DrawerComponent } from "@learningblocks/protocol-components";
import { DrawerHandle } from "@learningblocks/protocol-components";

export class Drawer extends React.Component {
  render() {
    return (
      <>
        {this.props.visible === false && <DrawerHandle />}
        <DrawerComponent
          expanded={this.props.expanded}
          visible={this.props.visible}
          showOverlay={this.props.showOverlay}
        >
          {this.props.children}
        </DrawerComponent>
      </>
    );
  }
}

Drawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
};
